export default __webpack_public_path__ + "static/cta-do-ea9416bcb050f2b7c08b9fa0d70e4742.png";